import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Button } from "@vwfs-bronson/bronson-react";

function FormSectionGroup2({ children }) {
  return <div className="c-form-section-group">{children}</div>;
}

function FormSection2(props) {
  const {
    className,
    success,
    title,
    subtitle,
    expanded,
    onHeaderClick,
    edit,
    children,
    containerRef,
    ...rest
  } = props;

  return (
    <div
      {...rest}
      ref={containerRef}
      className={cx(
        "c-form-section",
        { "c-form-section--success": success },
        className
      )}
      style={expanded ? { overflow: "visible" } : {}}
    >
      <div
        className={cx("c-form-section__header", { "is-active": expanded })}
        onClick={onHeaderClick}
      >
        <div className="c-form-section__header-content">
          <div className="c-form-section__title" aria-expanded={expanded}>
            <span className="c-form-section__title-text">{title}</span>
            {!expanded && edit && (
              <Button
                small
                link
                icon="pen"
                iconReversed={true}
                className={"c-form-section__title-link"}
                onClick={edit.onClick}
              >
                {edit.label}
              </Button>
            )}
          </div>

          <p className="c-form-section__subtitle">{subtitle}</p>
        </div>
        <span className="c-form-section__header-icon" />
      </div>

      <div className="c-form-section__panel" aria-hidden={!expanded}>
        <div className="c-form-section__content">{children}</div>
      </div>
    </div>
  );
}

FormSection2.propTypes = {
  /**
   * Controls the icon of the section
   */
  success: PropTypes.bool,
  /**
   * A text rendered as title in the header of the form section.
   */
  title: PropTypes.node,
  /**
   * A text rendered as subtitle in the header of the form section.
   */
  subtitle: PropTypes.node,
  expanded: PropTypes.bool,
  onHeaderClick: PropTypes.func,
  edit: PropTypes.shape({
    onClick: PropTypes.func,
    label: PropTypes.string.isRequired,
  }),
  children: PropTypes.object,
  containerRef: PropTypes.any,
};

export { FormSection2, FormSectionGroup2 };

/*

This implementation can't be used because bronson-react does not support
controlled form of FormSection. All the open/close mechanism is encapsulated
in the component, and we can't:

- prevent the user from having multiple forms opened
- prevent the user from opening form N+1 if N is not validated


import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Button, FormSection } from "bronson-react";

function FormSectionGroup2({ children }) {
  return <div className="c-form-section-group">{children}</div>;
}

function FormSection2(props) {
  const {
    className,
    success,
    title,
    subtitle,
    expanded,
    onHeaderClick,
    edit,
    children,
    containerRef,
    ...rest
  } = props;

  return (
    <FormSection
      {...rest}
      ref={containerRef}
      success={success}
      onClick={onHeaderClick}
      open={expanded}
      defaultOpen={expanded}
      headerContent={
        <>
          <button
            className="c-form-section__title"
            aria-expanded={expanded}
            type="button"
          >
            <span className="c-form-section__title-text">{title}</span>
            {!expanded && edit && (
              <Button
                small
                link
                icon="pen"
                iconSize="xsmall"
                iconReversed={true}
                className={"c-form-section__title-link"}
                onClick={edit.onClick}
              >
                {edit.label}
              </Button>
            )}
          </button>
        </>
      }
    >
      {children}
    </FormSection>
  );
}

export { FormSection2, FormSectionGroup2 };

*/
